import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["link"]

  connect() {
    this.cachedResults = null
  }

  download(event) {
    event.preventDefault()
    const { profile, filename } = event.currentTarget.dataset
    this.downloadProfile(profile, filename)
  }

  downloadAll(event) {
    event.preventDefault()
    this.linkTargets.forEach((link, i) => {
      setTimeout(() => {
        this.downloadProfile(link.dataset.profile, link.dataset.filename)
      }, i * 200)
    })
  }

  fetchResults() {
    if (this.cachedResults) return Promise.resolve(this.cachedResults)
    if (!this._fetchPromise) {
      this._fetchPromise = fetch(this.urlValue)
        .then(r => {
          if (!r.ok) throw new Error(`Failed to fetch results: ${r.status}`)
          return r.json()
        })
        .then(data => { this.cachedResults = data; this._fetchPromise = null; return data })
    }
    return this._fetchPromise
  }

  downloadProfile(profile, filename) {
    this.fetchResults().then(results => {
      const data = results[profile]
      if (!data) return

      let blob
      if (profile === "goroutine") {
        blob = new Blob([data], { type: "text/plain" })
      } else {
        const raw = atob(data)
        const bytes = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i)
        blob = new Blob([bytes], { type: "application/octet-stream" })
      }

      const a = document.createElement("a")
      a.href = URL.createObjectURL(blob)
      a.download = filename
      a.click()
      URL.revokeObjectURL(a.href)
    }).catch(() => {
      alert("Failed to download profile. Please try again.")
    })
  }
}
